import { createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import {User} from '../../features/login/models/user';

export interface AuthState {
  user: User | null;
}

export const initialState: AuthState = {
  user: null,
};

export const authReducer = createReducer(
  initialState,

  on(AuthActions.loginSuccess, (state, user: User) => ({
    ...state,
    user,
  })),

  on(AuthActions.logout, () => initialState)
);
